import { type ReactNode } from 'react';
import {Outlet} from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import {ScrollWrapper} from './styles';

const MainLayout = (): ReactNode => {
  return (
    <>
      <Header />
      <ScrollWrapper>
        <Outlet />
        <Footer />
      </ScrollWrapper>
    </>
  );
};

export default MainLayout;
